import React from 'react'
import Icon, { IconKey } from 'components/ui/icon'
import { Callout } from 'components/ds'
import type { RootProps } from '@radix-ui/themes/dist/cjs/components/callout.js'

type Props = RootProps & {
  icon: IconKey
  text: string | React.ReactElement
}

const BillingCallout = ({ icon, text, color = 'blue', size }: Props) => {
  return (
    <Callout.Root size={size} color={color} variant="soft">
      <Callout.Icon>
        <Icon type={icon} height={18} />
      </Callout.Icon>
      <Callout.Text>{text}</Callout.Text>
    </Callout.Root>
  )
}

export default BillingCallout
